export default {
  title: 'Strategie',
  sections: {
    strategy_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">Unsere Strategie</div> Maximale PERFORMANCE auf Augenhöhe',
            text2: 'Die SEU-Gruppe bringt die Besten der Branche zusammen',
            image: '/seu/latest-assets/seu_26.jpg',
          }
        },
      }
    },
    strategy_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Strategie'
          }
        }
      }
    },
    strategy_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_33.jpg',
          }
        }
      }
    },
    strategy_text_section: {
      fields: {
        field_one: {
          value: {
            text: 'Persönliche Chancen nutzen. Als Gruppe wachsen.'
          }
        },
        field_two: {
          value: {
            text: `Durch die Integration in die SEU-Gruppe übernehmen wir zukünftig gemeinsam die Verantwortung für Ihr Unternehmen. Unsere Vision: zusammen Höchstleistungen erbringen.`
          }
        },
        field_three: {
          value: {
            text: 'SEU ist die Plattform für Ingenieurinnen und Ingenieure in der Schweiz. Unsere Gruppe wächst durch den Kauf und die sanfte Integration gesunder KMU. Die ehemaligen Inhaber der Partnerunternehmen beteiligen sich dabei an der SEU.',
            text2: 'Wir sind Profis für Bau, Geomatik und Planung in der Deutschschweiz, inklusive internationalen Produktionsstätten. So können wir auch komplexe Projekte gut meistern, Auftragsspitzen professionell bearbeiten und unser Kerngeschäft weiterentwickeln.',
            text3: 'Wir bauen auf Innovationsgeist, Kompetenz und Unternehmertum. Mit einem Ziel: die Zukunft unserer Branche aktiv mitzugestalten. Gemeinsam mit Ihnen.'
          }
        },
      }
    },
    strategy_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Strategie'
          }
        }
      }
    },
    strategy_text_2_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">Unsere Business-Strategie</div> <br/> Von Ingenieuren für Ingenieure'
          }
        },
        field_two: {
          value: {
            text: '<p>Von Ingenieuren für Ingenieure - das ist die Antwort der SEU auf die aktuellen Herausforderungen der Ingenieur-Branche. Wir sind national ausgerichtet, bauen auf regional verankerte KMU und betreiben internationale Produktionsstätten.</p> <p>Als Gruppe vereinen wir die Stärken unserer Partnerunternehmen und entwickeln ihre Wettbewerbsvorteile gezielt weiter. Innovationen sind dabei DNA und Antrieb zugleich.</p> '
           }
        },
      }
    },
    strategy_divider3_section: {
      fields: {
        field_one: {
          value: {
            divider: ' Die SEU-Wachstumsstrategie: kaufen, vernetzen, entwickeln'
          }
        }
      }
    },
    strategy_features_section: {
      fields: {
        field_one: {
          value: {
            boxes: [
              {
                title: 'Akquisition',
                image: '/seu/latest-icons/growth.svg',
                subTitle: `Wir wachsen proaktiv durch gezielte Zukäufe. Wir legen Wert auf sorgfältig ausgesuchte Akquisitionen lokal verwurzelter, erfolgreicher Ingenieur-Unternehmen. Herausforderungen, welche kleinere Unternehmen ins Wanken bringen, sind im Experten-netzwerk leichter zu bewältigen.`,
              },
              {
                title: 'Regionale Exzellenz',
                image: '/seu/latest-icons/location.svg',
                subTitle: `Unser Ziel ist es, eine herausragende nationale Präsenz aufzubauen, die gleichzeitig international strahlt und begeistert. Die SEU vereint dabei leistungsstarke, regionale Kompetenzzentren, die als Pfeiler unserer Erfolgsgeschichte fungieren. Diese Struktur gewährleistet uns grösstmögliche Flexibilität und aussergewöhnliche Schlagkraft - sowohl auf regionaler und nationaler Ebene als auch im angrenzenden Ausland.`,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                title: 'Mehrmarken-Strategie',
                image: '/seu/latest-icons/market-strategy.svg',
                subTitle: `Wir leben eine leistungsstarke Mehrmarken-Strategie. Diese ermöglicht es jedem Partnerunternehmen, seine Marke und Eigenständigkeit weiterzuentwickeln, während es gleichzeitig von den Vorteilen und Synergieeffekten innerhalb der Gruppe profitiert:
<ul> <li>Cross-Sellings </li>
 <li> Skaleneffekte</li>
 <li> Margenstarke Performance</li>
 <li> Offshore-Produktionsstätten</li>
 <li> Neue Märkte und Aufgabenbereiche</li>
 <li> Wachsende Projektkapazität</li>
 <li> Gebündeltes Expertenwissen </li> </ul>`,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                title: 'Digitalisierung',
                image: '/seu/latest-icons/digitization.svg',
                subTitle: `Mit digitalen Innovationen und künstlicher Intelligenz schaffen wir als Gruppe wichtige Synergien und optimieren Ressourcen, um die operativen und administrativen Prozesse unserer Partnerunternehmen kontinuierlich zu verbessern.`,
              },
              {
                title: 'Kundenbindung ',
                image: '/seu/latest-icons/customer-loyalty.svg',
                subTitle: `Wir bauen unser Portfolio laufend aus. Kundennähe, Kundenorientierung und höchste Ansprüche an die Qualität unserer Dienstleistungen zeichnen uns aus. Wir arbeiten zusammen mit und für:
<ul> <li> Schweizer Architektinnen und Architekten </li>
<li> Private Bauherrschaften mit komplexen Herausforderungen</li>
<li> Unternehmen und Organisationen mit einem oder mehreren Standorten in der Schweiz oder im benachbarten Ausland</li>
<li> Amtsstellen der öffentlichen Hand (Bund, Kantone und Gemeinden)</li>`,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },

            ]
          }
        }
      }
    },
    strategy_divider4_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Mitarbeitende im Mittelpunkt'
          }
        }
      }
    },
    strategy_features_2_section: {
      fields: {
        field_one: {
          value: {
            boxes: [
              {
                title: 'Personalentwicklung',
                image: '/seu/latest-icons/stairs.svg',
                subTitle: `Wir leben Partizipation und fördern Weiterbildung: in der SEU-Akademie sowie über das SEU-Mitarbeiter-Beteiligungsprogramm. Dies sind optimale Rahmenbedingungen, um die individuellen Stärken und Potenziale der Mitarbeitenden gezielt weiterzuentwickeln und einzusetzen.`,
              },
              {
                title: 'Transparenz',
                image: '/seu/latest-icons/magnifying-glass.svg',
                subTitle: `Wir binden unsere Partnerunternehmen aktiv in den Integrationsprozess ein und unterstützen sie durch ein klar strukturiertes Onboarding-Konzept. Erwartungen und Ziele sowie alle Schritte der Integration sind von Anfang an und für alle Seiten transparent.`
              },
              {
                title: 'Vertrauen',
                image: '/seu/latest-icons/hand-heart.svg',
                subTitle: `Eine vertrauenswürdige und zuverlässige Kommunikation ist für uns selbstverständlich. Persönliche Prozess-Begleitung und Feedback-Runden sorgen dafür, dass wir alle Bedürfnisse kennen und berücksichtigen können.`
              },
              {
                title: 'Purpose',
                image: '/seu/latest-icons/hand-heart-2.svg',
                subTitle: `Persönlicher Sinn im Tun, Wertschätzung für Geleistetes sowie Raum und Zeit für fachliche und persönliche Entwicklungen motivieren. Das ist uns wichtig – denn es hält Mitarbeitende gesund und leistungsfähig.`
              },

            ]
          }
        }
      }
    },
    strategy_divider5_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Sanfte Integration'
          }
        }
      }
    },
    strategy_text_3_section: {
      fields: {
        field_one: {
          value: {
            text: 'Die sanfte Integrationsstrategie der SEU zeichnet sich durch eine sorgfältige und gezielte Vorgehensweise aus. Wir achten darauf, dass bei der Integration neuer Partnerunternehmen nur die notwendigsten Anpassungen vorgenommen werden. Dabei legen wir besonderen Wert auf den Erhalt des individuellen Markenbildes, des Marktprofils nach aussen sowie des einzigartigen Spirits der jeweiligen Unternehmenskultur.'
          }
        },
        field_two: {
          value: {
            text: 'Im Fokus stehen stattdessen eine hohe Effizienz, ein gesundes Wachstum und langfristige Synergieeffekte – im operativen Betrieb ebenso wie in kritischen Bereichen',
            text2: 'Durch diese gezielte Herangehensweise erreichen wir eine erfolgreiche Integration neuer Partnerunternehmen, ohne dabei den individuellen Charakter der einzelnen Unternehmen zu beeinträchtigen.',
            boxes: [
              {
                name: 'Administration und Digitalisierung'
              },
              {
                name: 'Marketing und Vertrieb'
              },
              {
                name: 'Rekrutierung von Fachkräften'
              },
              {
                name: 'Personalentwicklung'
              },
              {
                name: 'Optimale Auslastung'
              },
              {
                name: 'Entwicklung und Innovation'
              },
              {
                name: 'Nachfolgemanagement'
              },
            ]
          }
        },
      }
    },
    strategy_divider6_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Co-Unternehmertum'
          }
        }
      }
    },
    strategy_text_4_section: {
      fields: {
        field_one: {
          value: {
            text: 'Inhaberinnen und Inhaber, die ihre Unternehmen an die SEU verkaufen und sich aktiv an der Integration beteiligen, heissen wir als Co- Unternehmer/innen der Gruppe willkommen. Auch Mitarbeitende in Schlüsselpositionen dürfen zur Erfolgsgeschichte beitragen und Co- Unternehmer/innen werden. Als solche sind sie ein wichtiger Teil des Aktionariats und damit ein Puzzleteil des Erfolgs: Sie gestalten die Entwicklung der SEU mit und werden am Gewinn beteiligt.'
          }
        },
        field_two: {
          value: {
            text: 'Ihre Vorteile als Co-Unternehmer/in',
            boxes: [
              {
                name: 'Ihre Expertise wird Teil eines starken Netzwerks von Unternehmern mit nationaler Strahlkraft.'
              },
              {
                name: 'Sie gestalten die Zukunft der SEU-Gruppe mit und sind am Erfolg beteiligt.'
              },
              {
                name: 'Sie können sich auf eine erfolgreiche Nachfolgelösung verlassen.'
              },
              {
                name: 'Sie können Ihren Mitarbeitenden eine Beteiligung an der SEU-Gruppe offerieren.'
              },
            ]
          }
        },
      }
    },
    strategy_divider7_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Managementsupport'
          }
        }
      }
    },
    strategy_text_5_section: {
      fields: {
        field_one: {
          value: {
            text: 'Wir schätzen die bisherigen Erfolge unserer Partnerunternehmen und unterstützen das Management auf dem Weg in eine gemeinsame Zukunft.'
          }
        },
        field_two: {
          value: {
            text: 'Ihre Vorteile als Partnerunternehmen',
            boxes: [
              {
                name: 'Ihre Marke lebt weiter.'
              },
              {
                name: 'Ihr Unternehmen behält operative Freiheit und Selbstständigkeit.'
              },
              {
                name: 'Ihre bisherigen Kundenbeziehungen bleiben erhalten, gleichzeitig können Sie Ihr Portfolio gezielt ausbauen.'
              },
              {
                name: 'Ihre Mitarbeitenden können auf die gewohnte Unternehmenskultur vertrauen.'
              },
              {
                name: 'Ihre Firma profitiert von Synergieeffekten und bleibt langfristig wettbewerbsfähig.'
              },
            ]
          }
        },
      }
    },
    strategy_call_to_action_section: {
      fields: {
        field_one: {
          value: {
            text: 'Was ist Ihre zentrale Herausforderung?',
            text2: 'Packen wir sie an.',
            buttonLabel: 'Lösungen mit Win-Win',
            buttonLink: '/angebot',
            image: '/seu/latest-assets/seu_19.jpg',
          }
        },
      }
    },
    strategy_divider8_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Strategie'
          }
        }
      }
    },
    strategy_text_6_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">ERFOLGSSTORIES</div> UNSERER PARTNER-UNTERNEHMEN'
          }
        },
        field_two: {
          value: {
            text: 'Das Herz von Swiss Engineers United sind unsere Partnerschaften'
          }
        },
        field_three: {
          value: {
            text: 'Die erste Gesellschaft der SEU ist die <a href="https://hmq.ch/" target="_blank" class="text-highlight">HMQ AG</a> mit Sitz in Graubünden und weiteren Standorten in Aargau und Zürich.'
          }
        },
        field_four: {
          value: {
            text: 'Die HMQ AG setzt auf Innovation, Qualität und Technologie. Ihr Markenzeichen ist ein gut diversifiziertes Engineering-Portfolio mit international ausgerichteten Services. Die HMQ ist seit über 30 Jahren in der Engineering-Branche etabliert und seit vielen Jahren in der ganzen Deutschschweiz sowie im benachbarten Ausland tätig.',
            text2: 'Die Fakten:',
            boxes: [
              {
                name: '1974 gegründet'
              },
              {
                name: '2022 in die SEU integriert'
              },
              {
                name: 'Rund 50 Mitarbeitende in der Schweiz'
              },
              {
                name: 'Eigene Produktionsstätten in Ungarn und Indonesien mit rund 85 Mitarbeitenden'
              },
              {
                name: 'Pionier und Marktführer für BIM-fähige 3D-Gebäudedaten'
              },
              {
                name: 'Innovative und effiziente Technologien bei Beweissicherungsaufnahmen und weiteren Prozessen'
              },
              {
                name: 'Hoher Digitalisierungsgrad und überzeugendes Digital Marketing'
              },
              {
                name: 'Versiert in der Gewinnung von hochqualifizierten Fachkräften.'
              },
            ]
          },

        },
      }
    },
    strategy_divider9_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Das Resultat'
          }
        }
      }
    },
    strategy_call_to_action_2_section: {
      fields: {
        field_one: {
          value: {
            testimonials: [
              {
                text: '„Ich arbeite seit 30 Jahren als Geomatiker für die HMQ AG. Mit der Integration in die SEU-Holding ist der HMQ-Spirit erhalten geblieben. Die Möglichkeit, neue Tätigkeitsfelder und Einsatzgebiete zu erschliessen, spornt mich an, hier auch weiterhin zu bleiben.“',
                text2: 'Christian Schmid',
                image: '/seu/testimonial1.jpg'
              },
              {
                text: 'Als Mitglied der Geschäftsleitung HMQ Gruppe und Geschäftsführer der HMQ Gebäude AG habe ich die Integration in die SEU aktiv vorangetrieben. Das Geschäftsmodell überzeugt mich auf ganzer Linie',
                text2: 'Daniel Gantenbein',
                image: '/seu/testimonial1.jpg'
              }
            ]

          }
        },
      }
    },

  }
}
